import { Box } from "@mui/material";
import { SelectionOptions } from "../../../shared/SelectionOptions"
import { sortItems } from "../../schedulePage/schedulePageHelper"
import { RefreshButton } from "../../../shared/RefreshButton";

interface ScheduleEventsActionsProps {
    sortBy: string;
    onSortChange: (sortBy: string) => void;
    onRefresh: () => void;
    loading: boolean;
}

export const ScheduleEventsActions = ({
    sortBy, onSortChange, onRefresh, loading
}: ScheduleEventsActionsProps) => {

    return (
        <Box sx={{ display: 'flex', margin: '-8px -10px 0 0' }}>
            <Box>
                <SelectionOptions
                    id='events-sortitems'
                    items={sortItems}
                    value={sortBy}
                    onValueChange={(sort) => onSortChange(sort)}
                />
            </Box>
            <Box sx={{paddingLeft: '10px'}}>
                <RefreshButton
                    id='events-refresh'
                    tooltip="Refresh events"
                    loading={loading}
                    onClick={onRefresh}
                />
            </Box>
        </Box>
    )
}
